document.body.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul")
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE")
      return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form)
      form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);


function open_drawer__menu() {
  let menu_drawer;
    menu_drawer = document.querySelector('.menu-drawer--variant');
  document.addEventListener("click", function(e) {
    if(e.target.classList.contains('show_mobile_menu')){
      menu_drawer.classList.toggle('show_drawer_menu');
      document.body.classList.toggle('overflow-hidden')     
    }else if(e.target.classList.contains('menu-drawer--close')){
      menu_drawer.classList.toggle('show_drawer_menu');
      document.body.classList.toggle('overflow-hidden')
    }
  })
}

if (document.querySelector('.menu-drawer')) {
  open_drawer__menu();
}
